import EnhancedDefaultFormPrompt from './default-form-prompt'

export * from './default-form-prompt'

export { EnhancedDefaultFormPrompt }



// WEBPACK FOOTER //
// ./src/app/front-face/shared/default-form-prompt/index.ts